// src/routes/appRouter.tsx
import React from "react";
import { createBrowserRouter } from "react-router-dom";

// Storefront
import StorefrontHome from "../storefront/StorefrontHome";
import StorefrontThemesPreview from "../storefront/StorefrontThemesPreview";
import StorefrontThemePublicPreview from "../storefront/StorefrontThemePublicPreview";
import StoreNotFound from "../storefront/StoreNotFound";

// App/Dashboard pages
import Index from "../pages/Index";
import Auth from "../pages/Auth";
import Dashboard from "../pages/Dashboard";
import Customers from "../pages/Customers";
import Store from "../pages/Store";
import Stats from "../pages/Stats";
import StoreAnalytics from "../pages/StoreAnalytics";
import Settings from "../pages/Settings";
import DomainManagement from "../pages/DomainManagement";
import StoreSetup from "../pages/StoreSetup";
import ThemeSelection from "../pages/ThemeSelection";
import ThemeCustomization from "../pages/ThemeCustomization";
import ThemePublish from "../pages/ThemePublish";
import AdvertisingManager from "../pages/AdvertisingManager";
import AIContentGenerator from "../pages/AIContentGenerator";
import VideoCreator from "../pages/VideoCreator";
import PurchasePage from "../pages/PurchasePage";
import PaymentSuccess from "../pages/PaymentSuccess";
import NotFound from "../pages/NotFound";

export const appRouter = createBrowserRouter([
  // ✅ ROOT: tam landing (eski “tam sayfa” burası)
  { path: "/", element: <Index /> },

  // ✅ Vitrin: sadece Themes section’ı göstermek istersen
  { path: "/themes-preview", element: <StorefrontThemesPreview /> },

  // ✅ Public tema preview (login yok)
  { path: "/preview", element: <StorefrontThemePublicPreview /> },

  // ✅ Storefront (istersen ileride gerçek storefront home)
  { path: "/store", element: <StorefrontHome /> },
  { path: "/store-not-found", element: <StoreNotFound /> },

  // ✅ App/Dashboard route’ları
  { path: "/index", element: <Index /> },
  { path: "/auth", element: <Auth /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/dashboard/customers", element: <Customers /> },
  { path: "/dashboard/store", element: <Store /> },
  { path: "/dashboard/stats", element: <Stats /> },
  { path: "/dashboard/analytics", element: <StoreAnalytics /> },
  { path: "/dashboard/settings", element: <Settings /> },
  { path: "/dashboard/domain-management", element: <DomainManagement /> },
  { path: "/dashboard/store-setup", element: <StoreSetup /> },
  { path: "/dashboard/theme-selection", element: <ThemeSelection /> },
  { path: "/dashboard/theme-customization", element: <ThemeCustomization /> },
  { path: "/dashboard/theme-publish", element: <ThemePublish /> },
  { path: "/dashboard/advertising", element: <AdvertisingManager /> },
  { path: "/dashboard/ai-content", element: <AIContentGenerator /> },
  { path: "/dashboard/video-creator", element: <VideoCreator /> },
  { path: "/purchase", element: <PurchasePage /> },
  { path: "/dashboard/payment-success", element: <PaymentSuccess /> },

  // fallback
  { path: "*", element: <NotFound /> },
]);